import { useEffect, useState } from 'react';
import { FormInstance } from 'antd';

export const useHasValidDisputeFiles = (form: FormInstance) => {
  const [valid, setValid] = useState(true);

  // NOTE: antd does not update the form ref, so depending on `form` would leave this effect stale.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    let mounted = true;

    form
      .validateFields(['files'])
      .then(() => {
        mounted && setValid(true);
      })
      .catch(() => {
        mounted && setValid(false);
      });

    return () => {
      mounted = false;
    };
  });

  return valid;
};
